module.exports = __webpack_public_path__ + "static/media/gray_star.b16aa8ff.svg";